import { RootState } from '../store';
import {
  isBadgeNotificationType,
  isPaymentNotificationType,
  isRepaymentNotificationType
} from '../../pages/Dashboard/pages/Main/components/Notifications/useNotifications';
import { RepaymentNotification } from './notifications.model';

export const notificationsSelector = (state: RootState) => state.notifications;

export const selectPaymentNotifications = (state: RootState) =>
  state.notifications?.items.filter(isPaymentNotificationType);

export const selectRepaymentNotifications = (
  state: RootState
): RepaymentNotification[] =>
  state.notifications?.items.filter(isRepaymentNotificationType);

export const selectBadgeNotifications = (state: RootState) =>
  state.notifications?.items.filter(isBadgeNotificationType);
